import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { PaginationInfo } from "../../models/loan.model";

import { createStyles, makeStyles } from "@material-ui/core";
import { Grid, SelectChangeEvent } from "@mui/material";
import {
  NATIONAL,
  SUPPLIERIDS,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  SUPPLIER_ID,
  TABLE_FILTER,
} from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import createCache from "@emotion/cache";
import CheckIcon from "@mui/icons-material/Check";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import { createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
// import { Pagination } from "@mui/material";

import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { connect, useSelector } from "react-redux";
import {
  Filter,
  GetCartablesResponse,
  GetSupplierRequirementItemsResponse,
} from "../../models/cartable.model";
import { GetSuppliers } from "../../services/basicInformation.service";
import {
  GetCartables,
  GetSupplierRequirementItems,
} from "../../services/cartable.service";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "title", label: "نام پذیرنده" },
  { id: "storeTitle", label: "نام فروشگاه" },
  { id: "isTopRated", label: "پذیرنده برتر" },
  {
    id: "assigner",
    label: "ارجاع دهنده",
  },
  { id: "supplierStatusTitle", label: "وضعیت پذیرنده" },
];

let muiSelected: any;

function TableSupplierRequirmentCmp({
  stateCartable,
  status,
}: TableCmpPropsInterface) {
  /*********** filter added */
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected,
        },
      },
    })
  );
  const classes = useStyles();
  const [valueSupplierIds, setValueSupplierIds] = useState<string[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();

  useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
    onSuccess(data) {
      setSupplierIdsOptions(data);
    },
  });

  let row: any;
  const queryClient = useQueryClient();
  const oldPage = queryClient.getQueryData<Filter>(TABLE_FILTER);
  const activePage = localStorage.getItem("setActivePage");

  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();

  const [selectedRow, setSelectedRow] = useState(undefined);

  const [data, setData] = React.useState<GetSupplierRequirementItemsResponse[]>(
    []
  );
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [cartableRes, setCartableRes] = useState<GetCartablesResponse[]>([]);
  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER);
      setSelectedRow(row?.rowNumber);
    }
    const filter = new Filter();
    filter.state = stateCartable.stateCartable;
    let nationalCache = queryClient.getQueryData<string>(NATIONAL);
    let suppIdCache = queryClient.getQueryData<string[]>(SUPPLIER_ID);
    filter.customerNationalCode = nationalCache;
    filter.supplierIds = suppIdCache;
    if (stateCartable.stateCartable) {
      // fillData(filter);
    }
    queryClient.setQueryData(TABLE_FILTER, filter);
  }, [stateCartable]);

  const GetSupplierRequirementItemsMutation = useMutation(
    GetSupplierRequirementItems,
    {
      onSuccess: (
        result: ApiResultModel<GetSupplierRequirementItemsResponse[]>
      ) => {
        if (result) {
          setData(result.data);
          setPageInfo(result.pageInfo);
        }
      },
    }
  );

  const { mutate: GetCartablesMutate } = useMutation(GetCartables, {
    onSuccess: (data: GetCartablesResponse[]) => {
      if (data) {
        setCartableRes(data);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetCartablesMutate({
      workflowType: "SupplierRequirements",
    });
  }, []);

  useEffect(() => {
    GetSupplierRequirementItemsMutation.mutate({
      filter: {
        customerNationalCode: "",
        // state: "WaitForCreditApprove",
        state: stateCartable.stateCartable,
        supplierIds: [],
      },
      paginationInfo: {
        pageNumber: 1,
        pageSize: 10,
      },
    });
  }, [stateCartable]);

  const changePageNumber = (newPageNumber: number) => {
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    // fillData(tabelFilter!);
    // fillData(new Filter())
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  const handleChangeMultiselect = (
    event: SelectChangeEvent<typeof loanRequestOptions>
  ) => {
    const {
      target: { value },
    } = event;
  };
  const handleDetail = (supplierId: number, rowIndex: number) => {
    // window.sessionStorage.setItem("id", String(supplierId));
    localStorage.setItem("SUPPLIER_ID", String(supplierId));
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);

    history.push({
      pathname: `/loan/${activePage}1/requirment-detail`,
      state: {
        id: String(supplierId),
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
      },
    });
  };

  function deleteChip() {
    setValueSupplierIds([]);
    queryClient.setQueryData(SUPPLIER_ID, []);
    setValueSupplier([]);
    setValueCustomerNationalCode("");
    queryClient.setQueryData<string>(NATIONAL, "");
    queryClient.setQueryData(SUPPLIER_ID, null);
    const filter = new Filter();
    filter.state = stateCartable.stateCartable;
    // fillData(filter);
    changePageNumber(1);
  }
  const filter = new Filter();
  filter.state = " []";

  const handleSelectRow = (rowIndex: any) => {
    const filter = new Filter();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    // queryClient.setQueryData(TABLE_FILTER, filter);
  };

  return (
    <>
      <div className="cardTableBorder">
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                ></TableCell>
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.supplierId}
                        selected={selectedRow === rowIndex}
                        onClick={() => handleDetail(row.supplierId!, rowIndex)}
                      >
                        <TableCell className="textFont12" align="right">
                          {row.isInUserCartable ? (
                            <EmojiObjectsIcon
                              style={{ color: "#fbc02d", fontSize: "25px" }}
                            />
                          ) : (
                            <EmojiObjectsOutlinedIcon
                              style={{ color: "#C1C7CB", fontSize: "25px" }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          className="textFont12"
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetSupplierRequirementItemsResponse
                            ];
                          if (column.id === "isTopRated")
                            return value === true ? (
                              <TableCell
                                className="textFont12"
                                key={column.id}
                                align="right"
                              >
                                <CheckIcon color={"success"} />
                              </TableCell>
                            ) : (
                              <TableCell
                                className="textFont12"
                                key={column.id}
                                align="right"
                              ></TableCell>
                            );
                          return (
                            <>
                              <TableCell
                                className="textFont12"
                                key={column.id}
                                align="right"
                              >
                                {column.format && column.hasFormat
                                  ? column.format(value)
                                  : value?.toString()}
                              </TableCell>
                            </>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(TableSupplierRequirmentCmp));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
